import { TICKET_CLASS } from "pages/AccountSettlementHistoryOrderId/constants/TicketClass";

type TicketClass = (typeof TICKET_CLASS)[keyof typeof TICKET_CLASS];

const TICKET_CLASS_VALUES = Object.values(TICKET_CLASS);

export const getTicketClass = (
  maybeTicketClass: number | undefined
): TicketClass => {
  const maybeFound = TICKET_CLASS_VALUES.find(
    (value) => value === maybeTicketClass
  );
  return maybeFound ?? TICKET_CLASS.VENUE;
};
